import * as Icons from './icons';

/* @ngInject */
export default function IconBootstrap($templateCache) {
    Object.keys(Icons).forEach((iconKey) => {
        const icon = Icons[iconKey];
        $templateCache.put(icon.url, icon.src);
    });
}
